module.exports = function() {
  return new Worker(__webpack_public_path__ + "b6fa4d3cace0e7905383.worker.js");
};